<mat-toolbar class="mat-elevation-z3 sticky-toolbar" style="z-index: 2; position: relative; font-family: Poppins; background:white;height: 90px;">

  <img routerLink="/home" src="../../assets/simpli/simpli.svg" height="70px" class="logo-new-simpli"/>

  <div class="flex-toolbar" style="position: relative;">

    
    <div class="logo">
      <button style="z-index: 999999999;" mat-icon-button class="icon-menu-desktop" (click)="open_menu()"><mat-icon style="color:#1B0943;">menu</mat-icon></button>
    </div>

    <span class="example-spacer"></span>


    <div class="user-info">
      <div class="user-info-container  animate__animated animate__fadeIn">

        <div class="avatar-container animate__animated animate__fadeIn">
          <img *ngIf="this.hasAvatar" (click)="upload_avatar()" class="user_image" src="{{this.avatar}}">
          
          <div *ngIf="!this.hasAvatar" class="my-avatar" (click)="upload_avatar()">
            <span id="avatar">{{ this.initials }}</span>
          </div>
        </div>

        <div class="user-details animate__animated animate__fadeIn">
          <div class="name_user animate__animated animate__fadeIn">¡Hola {{ capitalizeName() }}!</div>
          <div class="run_user animate__animated animate__fadeIn">{{run}}</div>
        </div>

      </div>
    </div>

  </div>

  &nbsp;
  &nbsp;
</mat-toolbar>

<mat-sidenav-container style="min-height: 100vh;" [hasBackdrop]="false" (backdropClick)="close_menu($event)">


  <mat-sidenav (mouseleave)="mouseleave($event)" *ngIf="display" style="background-color: white;" class="lale mat-elevation-z3 animate__animated animate__fadeIn animate__faster menusimpli w-custom" #sidenav [mode]="mode" [(opened)]="opened">

    <app-menu-simpli/>

  </mat-sidenav>


  <mat-sidenav-content style="min-height: 100vh;overflow: hidden; background-color: #f8f8f8;">
    <div class="row row_main"></div>




    <router-outlet>
    </router-outlet>




  </mat-sidenav-content>



</mat-sidenav-container>


